import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20manga%20style%20illustration%20with%20warm%20romantic%20atmosphere%2C%20soft%20gradient%20background%20in%20crimson%20and%20gold%20tones%2C%20artistic%20abstract%20composition%20with%20flowing%20lines%2C%20sophisticated%20Japanese%20aesthetic%2C%20dreamy%20ethereal%20mood%2C%20clean%20minimalist%20design%20elements&width=1800&height=900&seq=hero-hmanga-2026&orientation=landscape"
        alt="h漫画 - 精选成人漫画在线阅读平台"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
            精选成人漫画
            <span className="block text-accent-400 mt-2">随时随地 畅享阅读</span>
          </h1>
          <p className="text-white/70 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚海量h漫画资源，涵盖日系、国产、韩漫等多种风格，内容持续更新，
            为您提供最优质的h漫画阅读体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/japanese"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap backdrop-blur-sm cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="flex items-center gap-3 text-white/50 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            日系·国产·韩漫
          </span>
          <span className="w-1 h-1 rounded-full bg-white/30"></span>
          <span className="flex items-center gap-1">
            <i className="ri-refresh-line w-4 h-4 flex items-center justify-center"></i>
            每日更新
          </span>
          <span className="w-1 h-1 rounded-full bg-white/30"></span>
          <span className="flex items-center gap-1">
            <i className="ri-device-line w-4 h-4 flex items-center justify-center"></i>
            多端阅读
          </span>
        </div>
      </div>
    </section>
  );
}